import { ErrorAlertBox, InactiveAlertBox, WarningAlertBox } from "../../../../components/AlertBoxes.styled";
import { ComplianceStatus } from "../../../../types";

interface ComplianceMessageProps {
  status: number;
  message: string;
}

const ComplianceMessage: React.FC<ComplianceMessageProps> = ({ status, message }) => {
  if (status === ComplianceStatus.Failed) {
    return <ErrorAlertBox>{message}</ErrorAlertBox>
  } else if (status === ComplianceStatus.Expiring) {
    return <WarningAlertBox>{message}</WarningAlertBox>
  } else if (status === ComplianceStatus.Inactive) {
    return <InactiveAlertBox>{message}</InactiveAlertBox>
  }
}

export default ComplianceMessage;